import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  progress: {
    height: 10,
    borderRadius: 5,
  },
  dialogContent: {
    padding: '30px',
    width: '550px',
    minHeight: '205px'
  },
  actionsHolder: {
    padding: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  resultsContainer: {
    overflowY: 'auto',
    flexFlow: 'column nowrap',
    display: 'flex',
    marginTop: '8px',
    marginBottom: '20px',
    maxHeight: '250px',
  },
  resultText: {
    height: '24px',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '24px',
    letterSpacing: 'normal',
    color: '#12a312'
  },
  errorResult: {
    color: 'red'
  },
  oddRow: {
    background: '#fafafa'
  },
  resultRow: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0'
  },
  dialogHeader: {
    paddingLeft: '20px',
    paddingRight: '13px',
    ...theme.dialogs.header,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '60px',
    minHeight: '60px'
  },
  iconBtnStyle: {
    width: '30px',
    height: '30px',
    borderRadius: 6,
    padding: 0
  },
  headerTitle: {
    ...theme.dialogs.title
  },
  label: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#7f7182'
  },
  detailsExpand: {
    cursor: 'pointer',
    display: 'flex'
  },
  nameCell: {
    height: '45px',
    width: '240px',
    maxWidth: '240px',
    paddingLeft: "20px",
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    alignItems: "center",
    textOverflow: 'ellipsis',
    lineHeight: '45px',
    paddingRight: '30px',
  },
  progressPercent: {
    width: '25px',
    marginLeft: '16px',
    fontWeight: 500,
  },
  LinearProgressContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  failedText: {
    color: '#f8b133',
    marginLeft: '20px'
  },
  errorText: {
    marginBottom: '20px',
    width: '360px',
    color: 'red'
  }
}));

export default useStyles;
